import position from "./position.js";
import elementBase from "../element/elementBase.js";
import positionItem from "./position.js";
import base from "../base.js";
import screenSize from "../definition/screenSize.js";
import creator from "../element/creator.js";
import { reactive } from 'vue'

export default class Container extends base {
    objectType = "ContainerItem";
    Position = null;
    _Contents = [];//list class element
    constructor(args = {}, virtual = false) {
        super(args);
        if (virtual == false)
            this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        let contents = [];
        args = this.constructor.fromObjectToObject(args);
        if (args.contents) {
            for (const el of args.contents) {
                contents.push(creator(el.objectType, el));
            }
        }
        args.contents = contents;
        super.objectToClassValue(args);
        this.Repeat = args.repeat;
        if (args.position) {
            if (args.position.objectType == "PositionItem") {
                this.Position = args.position;
            }
            else {
                this.Position = new positionItem(args.position);
            }
        }
        else {
            this.Position = new positionItem({ x: 0, y: 0, largeur: 1080, hauteur: 1920 });
        }
        this.Contents = args.contents ? args.contents : [];
        this.Position.parent = this;
        this.Contents.forEach((c) => {c.parent = this});
        this.CanBeRemove = !this.parent || this.parent.objectType != "CompositionItem";
        if (this.VisibilityAtTheSameTime == false) {
            if (this.Contents) {
                let showed = false;
                this.Contents.forEach((el, index) => {
                    if (!this.HideElementType || this.HideElementType == el.objectType) {
                        if (!showed) {
                            showed = true;
                            el._Show = true;
                        }
                        else el._Show = false;
                    }
                });
            }
        }
    }

    get Contents() {
        return this._Contents;
    }
    set Contents(value) {
        this._Contents = reactive(value);
    }

    get ExportNamedElement() {
        return this.Name;
    }

    static get Name() {
        return "Containeur";
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Position", type: "objectInput", dataType: "object", options: position },
            { name: "Contents", type: "arrayInput", dataType: "object", elementOption: "pageElement", options: elementBase, elements: { name: "Contents", type: "objectInput", dataType: "object", options: elementBase } },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Position", construct: positionItem, jsType: "Class" },
            { property: "Contents", construct: elementBase, jsType: "Array" },
            { property: "CanAddElement", construct: Boolean, jsType: "Boolean" },
        ];
    }
    setIdToChildren(value) {
        this.Contents.forEach(el => {
            el.id = value;
        });
    }
    swapArrayElement(index, move) {
        if (index < 0 || index > this.Contents.length) return;
        this.Contents.splice(index + move, 0, this.Contents.splice(index, 1)[0]);
    }

    getStyle(currentElementIndex = null) {
        return {
            ...super.getStyle(currentElementIndex),
            position: 'absolute',
            left: this.Position ? `${this.Position?.x || 0}px` : '0px',
            top: this.Position ? `${this.Position?.y || 0}px` : '0px',
            width: this.Position ? `${this.Position?.width || 200}px` : `${screenSize.width}px`,
            height: this.Position ? `${this.Position?.height || 100}px` : `${screenSize.height}px`,
            cursor: 'move'
        };
    }
    static fromObject(object = {}) {
        return new this.prototype.constructor(object);
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            position: this.Position ? this.Position.toExportObject(variableArray, ressourceArray) : null,
            contents: this.Contents.length > 0 ? this.Contents.map(el => el.toExportObject(variableArray, ressourceArray)) : [],
        }
    }
    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            position: this.Position ? this.Position.toObject(minify) : null,
            contents: this.Contents.length > 0 ? this.Contents.map(el => el.toObject(minify)) : [],
            canAddElement: this.canAddElement,
        }
    }
    getFromPreviewId(id) {
        if (super.hasPreviewId(id) == true)
            return this;
        for (const el of this.Contents) {
            let result = el.getFromPreviewId(id);
            if (result != null)
                return result;
        }
        if (this.Position != null) {
            return this.Position.getFromPreviewId(id);
        }
        return null;
    }
    get isDraggable() {
        if (this.Position == null)
            return false;
        return true;
    }
    updatePosition(deltaX, deltaY) {
        super.updatePosition(deltaX, deltaY);
        for (const el of this.Contents) {
            el.updatePosition(deltaX, deltaY);
        }
    }
}
